<template>
    <sections>
        <app-subheader title="Details" :parent="{title: 'Classes', route: '/classes'}" :dark="true">
            <button-subheader
                v-if="isDirector && details"
                buttonIcon="edit"
                buttonText="Edit"
                :buttonHref="$config.public.admin.class + details.id"
                :dark="true"
            ></button-subheader>
        </app-subheader>
        <section-jumbo
            v-if="details"
            padding="py-20 sm:py-24 md:py-16 xl:py-20 2xl:py-24"
            :heading="details.name"
            headingColor="text-white"
            :content="details.address ? `<p>${details.address}</p>` : null"
            contentColor="text-zinc-100"
            :buttonText="details.website ? 'Website' : null"
            :buttonUrl="details.website || null"
        ></section-jumbo>
        <section-text
            v-if="details && details.description"
            heading="Class Details"
            headingComponent="h2"
            :content="details.description"
        ></section-text>
        <section-text
            v-if="details && details.description"
            padding="pb-10 sm:pb-14"
            content="<article-class-suggest-edit />"
        ></section-text>
        <section-text
            v-if="details && details.website && details.description"
            color="bg-zinc-50"
            heading="Get Involved!"
            headingComponent="h2"
            content="<p>Visit the website to join this class.</p>"
            buttonText="Website"
            :buttonUrl="details.website"
        ></section-text>
        <section-text
            v-if="error"
            heading="404 Not Found"
            content="<p>Apologies, but we can't find that class.</p>"
        ></section-text>
        <loading-spinner v-if="details === null && !error"></loading-spinner>
    </sections>
</template>

<script setup>
const classSlug = useRoute().params.classSlug;

const {isDirector} = storeToRefs(useStoreAuth());

const {error, details} = storeToRefs(useStoreClass());
const {getClass} = useStoreClass();

await useLazyAsyncData('getClass' + classSlug, () => getClass(classSlug).then(() => true));

useSeoClass().buildReactiveHead(details, error);
</script>
